import { GOTO_TOPBAR_CONTAINER_SELECTOR } from '../../common/container'
import { getDocument } from '../../common/dom-helpers'
import { GoToTopbar } from '../../packages/topbar/topbar'
export class TopbarService {
  private topbarElement: HTMLElement | undefined
  topbarContainerSelector = GOTO_TOPBAR_CONTAINER_SELECTOR

  show() {
    if (!this.topbarElement) {
      this.topbarElement = getDocument().createElement(GoToTopbar.tagName)
    }
    const topbarContainer = getDocument().querySelector(this.topbarContainerSelector)
    if (this.topbarElement.parentElement !== topbarContainer) {
      topbarContainer?.appendChild(this.topbarElement)
    }
  }

  hide() {
    if (this.topbarElement?.parentElement) {
      this.topbarElement?.remove()
    }
  }

  isVisible() {
    return !!this.topbarElement
  }
}
